import axios from "axios";

const URL = import.meta.env.VITE_AUTH_URL;

export const GetTransactionsDetailsService = (token, elementId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${URL}/api/epayco/v1/transaction-details?id=${elementId}`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        }
      );
      resolve(response.data.data);
    } catch (error) {
      reject(error);
    }
  });
};